import { Spin } from 'antd';

export function PageLoader() {
  return (
    <div className="flex min-h-[200px] items-center justify-center">
      <Spin size="large" />
    </div>
  );
}
